import React from 'react';
import StarRating from '../fragments/star-rating';
import iconCheck from '~/images/icon-table-check.svg';
import iconCheckRed from '~/images/icon-table-check-red.svg';
import iconCross from '~/images/icon-table-cross.svg';
import iconCrossGreen from '~/images/icon-table-cross-green.svg';
import iconCheckMark from '~/images/check-mark-green.svg';
import iconCrossedMark from '~/images/crossed-mark-red.svg';
import iconInfinityOrange from '~/images/infinity-orange.svg';

const Table = ({ block }) => {
  let highlightedIndex = 0;
  block.head_columns.map((column, index) => {
    if (column.highlighted) {
      highlightedIndex = index;
    }
    return null;
  });

  const { theme } = block;
  const themeClass = theme ? `table--${theme}` : '';

  return (
    <section
      className={`block ${block._template} ${block.css_class_name} ${themeClass}`}
    >
      <div className='container'>
        <div className='table-wr'>
          <table id='table'>
            <thead>
              <tr>
                <th className='table__title'>
                  {block.title ? (
                    <div
                      className='feature'
                      dangerouslySetInnerHTML={{ __html: block.title }}
                    ></div>
                  ) : null}
                </th>
                {block.head_columns.map((column, index) => {
                  return (
                    <th
                      key={index}
                      className={`${index === highlightedIndex ? 'is-highlighted' : ''}`}
                    >
                      <div className='td-bg'></div>
                      <div className='value'>
                        {column.image ? (
                          <img
                            src={column.image}
                            alt={column.title}
                            title={column.title}
                          />
                        ) : (
                          <div
                            className='title'
                            dangerouslySetInnerHTML={{ __html: column.title }}
                          ></div>
                        )}
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {block.rows.map((row, index) => {
                let rowColumns = row.columns.map((column, index) => {
                  const rating = column.rating;
                  let columnIcon = '';
                  if (column.icon === 'Check') {
                    columnIcon = iconCheck;
                  } else if (column.icon === 'Cross') {
                    columnIcon = iconCross;
                  } else if (column.icon === 'Cross - Green') {
                    columnIcon = iconCrossGreen;
                  } else if (column.icon === 'Check - Red') {
                    columnIcon = iconCheckRed;
                  } else if (column.icon === 'Pretty Check - Green') {
                    columnIcon = iconCheckMark;
                  } else if (column.icon === 'Pretty Cross - Red') {
                    columnIcon = iconCrossedMark;
                  } else if (column.icon === 'Infinity - Orange') {
                    columnIcon = iconInfinityOrange;
                  }

                  const hasIcon = columnIcon !== '' || rating;

                  return (
                    <td
                      key={index}
                      className={`${index === highlightedIndex ? 'is-highlighted' : ''}`}
                    >
                      <div className='td-bg'></div>
                      <div
                        className={`value ${column.bold ? 'is-bold' : ''} ${hasIcon ? 'has-icon' : ''}`}
                      >
                        <div className='content'>
                          {columnIcon && (
                            <img
                              src={columnIcon}
                              alt={column.title}
                              title={column.title}
                            />
                          )}
                          {rating && (
                            <StarRating
                              rating={rating.current_rating}
                              maxRating={rating.max_rating}
                              numberOfStars={rating.number_of_stars}
                            />
                          )}
                          {column.title && (
                            <div
                              dangerouslySetInnerHTML={{ __html: column.title }}
                            ></div>
                          )}
                          {column.subtitle && (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: column.subtitle,
                              }}
                            ></div>
                          )}
                        </div>
                      </div>
                    </td>
                  );
                });
                return (
                  <tr key={index}>
                    <td>
                      <div className='feature'>
                        {row.title && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: row.title,
                            }}
                          ></div>
                        )}
                        {row.subtitle && (
                          <div
                            className='subtitle'
                            dangerouslySetInnerHTML={{
                              __html: row.subtitle,
                            }}
                          ></div>
                        )}
                      </div>
                    </td>
                    {rowColumns}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {block.text && (
          <div
            className='text-formatted'
            dangerouslySetInnerHTML={{ __html: block.text }}
          ></div>
        )}
      </div>
    </section>
  );
};

export default Table;
